// extracted by mini-css-extract-plugin
export var widgetBlock = "AuthorBlock-module--widgetBlock--14WQQ";
export var blockWrapper = "AuthorBlock-module--blockWrapper--3GIW1";
export var authorImage = "AuthorBlock-module--authorImage--3iAeT";
export var authorName = "AuthorBlock-module--authorName--2xI3B";
export var authorBlockImage = "AuthorBlock-module--authorBlockImage--1UojO";
export var paragraphBlock = "AuthorBlock-module--paragraphBlock--3w19L";
export var descriptionBlock = "AuthorBlock-module--descriptionBlock--pfQay";
export var readMore = "AuthorBlock-module--readMore--3tjP6";